export default __webpack_public_path__ + "static/media/education.1026e878.png";